export default __webpack_public_path__ + "static/media/cloud-upload.42025dbe.svg";